module.exports = __webpack_public_path__ + "static/menu-wakaba-min3-008eba9bdcf8eb80bf4a32a050d55703.jpg";